<div class="rating">
  <div class="rating-current">
    <span class="rating-current-text">
      Рейтинг продукта
    </span>
    <span class="rating-current-value">
      {{ productCardData().ratingValue || 0 | formatNumber }}
    </span>
  </div>
  <button
    mat-stroked-button
    color="primary"
    type="button"
    class="rating-btn"
    (click)="handleRating()"
  >
    Рассчитать рейтинг
  </button>
</div>
